import React from "react";
import { FaCheck, FaTruck, FaBox, FaHome, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../styles/shippingProgress.css";

const ShippingProgress = ({ orderProgress = [] }) => {
  if (!orderProgress || orderProgress.length === 0) {
    return (
      <div className="shipping-progress">
        <h3>Shipping Progress</h3>
        <p className="no-progress">No progress updates available yet.</p>
      </div>
    );
  }

  const getStatusIcon = (status) => {
    const statusLower = status.toLowerCase();
    if (
      statusLower.includes("pending") ||
      statusLower.includes("ordered") ||
      statusLower.includes("confirmed")
    ) {
      return <FaCheck />;
    } else if (
      statusLower.includes("packaging") ||
      statusLower.includes("processing")
    ) {
      return <FaBox />;
    } else if (
      statusLower.includes("shipping") ||
      statusLower.includes("shipped") ||
      statusLower.includes("in transit") ||
      statusLower.includes("delivering")
    ) {
      return <FaTruck />;
    } else if (
      statusLower.includes("delivered") ||
      statusLower.includes("arrived")
    ) {
      return <FaHome />;
    } else if (statusLower.includes("cancelled")) {
      return <FaTimes />;
    }
    return <FaCheck />;
  };

  const getStatusMessage = (status) => {
    const statusLower = status.toLowerCase();

    if (statusLower.includes("pending")) {
      return "Your order was received and is ready to be processed";
    } else if (statusLower.includes("packaging")) {
      return "Your order is being packaged and prepared for shipment to the transport area";
    } else if (statusLower.includes("shipping")) {
      return "Your order is on its way from Korea to Kigali, Rwanda";
    } else if (statusLower.includes("arrived")) {
      return "Your order has arrived in Kigali and is being checked. Please be ready to be contacted soon";
    } else if (statusLower.includes("delivering")) {
      return "Your order is on its way and being delivered to your address";
    } else if (statusLower.includes("delivered")) {
      return "Your order was successfully delivered! Thank you for shopping with K-Shop.";
    } else if (statusLower.includes("cancelled")) {
      return (
        <>
          Your order was cancelled. If you think this was a mistake, please{" "}
          <Link to="/contactus" className="contact-link">
            contact us
          </Link>
        </>
      );
    } else {
      return status; // Fallback to original status if no custom message
    }
  };

  const getStatusColor = (status, index, total) => {
    const statusLower = status.toLowerCase();
    if (index === total - 1) {
      // Latest status - active color
      if (
        statusLower.includes("delivered") ||
        statusLower.includes("arrived")
      ) {
        return "var(--status-delivered)";
      } else if (
        statusLower.includes("shipping") ||
        statusLower.includes("shipped") ||
        statusLower.includes("in transit") ||
        statusLower.includes("delivering")
      ) {
        return "var(--status-delivering)";
      } else if (
        statusLower.includes("packaging") ||
        statusLower.includes("processing")
      ) {
        return "var(--status-packaging)";
      } else if (statusLower.includes("cancelled")) {
        return "var(--status-cancelled)";
      } else {
        return "var(--status-processing)";
      }
    } else {
      // Completed statuses
      if (statusLower.includes("cancelled")) {
        return "var(--status-cancelled)";
      }
      return "var(--status-success)";
    }
  };

  return (
    <div className="shipping-progress">
      <h3>Shipping Progress</h3>
      <div className="progress-timeline">
        {orderProgress.map((progress, index) => (
          <div key={progress.order_progress_id} className="progress-item">
            <div
              className="progress-icon"
              style={{
                backgroundColor: getStatusColor(
                  progress.status,
                  index,
                  orderProgress.length
                ),
                borderColor: getStatusColor(
                  progress.status,
                  index,
                  orderProgress.length
                ),
              }}
            >
              {getStatusIcon(progress.status)}
            </div>
            <div className="progress-content">
              <div className="progress-header">
                <h4 className="progress-status">{progress.status}</h4>
                <span className="progress-date">
                  {new Date(progress.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </span>
              </div>
              <p className="progress-message">
                {getStatusMessage(progress.status)}
              </p>
            </div>
            {index < orderProgress.length - 1 && (
              <div className="progress-connector"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShippingProgress;
